'use strict';
/* jshint ignore:start */

var reminders = {

		addReminderEvent: function (e, reminderID) {
			var occasionDate = $('#edit-reminder-form').find('#dwfrm_profile_reminders_eventdate').val();
			var reminderDate = getReminderDate(occasionDate);
			var obj = {
				button_ID: e.target.id ? e.target.id : e.target.innerText,
				reminder_date: reminderDate,
				reminder_occasion: $('#edit-reminder-form').find('[name$="reminderoccasion"]').val(),
				reminder_occasion_date: occasionDate,
				re_annual_reminder: $('#edit-reminder-form').find('#dwfrm_profile_reminders_annualreminder').is(":checked"),
				re_reminder_title: $('#edit-reminder-form').find('#dwfrm_profile_reminders_remindertitle').val(),
				re_reminder_id: reminderID,
				event: 'Add Reminder'
			};
			dataLayer.push(obj);
		},

		editReminderEvent: function (e) {
			var urlParts = $('#reminders a').attr('href').split('=', 2);
			var occasionDate = $('#edit-reminder-form').find('#dwfrm_profile_reminders_eventdate').val();
			var reminderDate = getReminderDate(occasionDate);
			var obj = {
				button_ID: e.target.id ? e.target.id : e.target.innerText,
				reminder_date: reminderDate,
				reminder_occasion: $('#edit-reminder-form').find('[name$="reminderoccasion"]').val(),
				reminder_occasion_date: occasionDate,
				re_annual_reminder: $('#edit-reminder-form').find('#dwfrm_profile_reminders_annualreminder').is(":checked"),
				re_reminder_title: $('#edit-reminder-form').find('#dwfrm_profile_reminders_remindertitle').val(),
				re_reminder_id: urlParts[1],
				event: 'Edit Reminder'
			};
			dataLayer.push(obj);
		},


		removeReminderEvent: function (e) {
			var urlParts = $('#reminders a').attr('href').split('=', 2);
			var obj = {
				button_ID: e.target.id ? e.target.id : e.target.innerText,
				reminder_type:  $('.addressbook-address .show .data:nth(0) span:nth-child(1)').text().trim(),
				reminder_date: $('.addressbook-address .show .data:nth(2) span:nth-child(1)').text().trim(),
				reminder_occasion: $('.addressbook-address .show .data:nth(0) span:nth-child(1)').text().trim(),
				reminder_occasion_date: $('.addressbook-address .show .data:nth(1) span:nth-child(1)').text().trim(),
				re_annual_reminder: $('.addressbook-address .show .data:nth(3) span:nth-child(1)').text().trim(),
				re_message:$('.addressbook-address .show .data:nth(4) span:nth-child(1)').text().trim(),
				re_reminder_title: $('h4.toggle-title.on').text().trim(),
				re_reminder_id: urlParts[1],
				event: 'Remove Reminder'
			};
			dataLayer.push(obj);
		}
}

/**
 * Utility function to get reminder date based on occasion date and days before event from site preferences
 *
 * @returns {String}
 */
function getReminderDate(occasionDate) {
    var daysBeforeEventToRemind = parseInt($('input[name="daysBeforeEventToRemind"]').val(), 10);
	var occasionDateParts = occasionDate.split('/');
	var reminderDate = new Date(occasionDateParts[2], occasionDateParts[1] - 1, occasionDateParts[0]);
	reminderDate.setDate(reminderDate.getDate() - daysBeforeEventToRemind);
	var reminderDateStr = ('0' + reminderDate.getDate()).slice(-2) + '/' + ('0' + (reminderDate.getMonth() + 1)).slice(-2) + '/' +  reminderDate.getFullYear();
	return reminderDateStr;
}

module.exports = reminders;
/* jshint ignore:end */
